import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = {
  key: 2,
  class: "row"
}
const _hoisted_4 = {
  class: "row",
  v: "receiverStats.alerts"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReceiverStatsDisplayCard = _resolveComponent("ReceiverStatsDisplayCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.receiverStats.sheqsy)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_ReceiverStatsDisplayCard, {
            label: 'Sheqsy',
            title: _ctx.getHumanDateOffset(_ctx.receiverStats.sheqsy.last.Timestamp) + ' : ' + _ctx.receiverStats.sheqsy.last.Message,
            counters: [
                { name: '10 min', value: _ctx.receiverStats.sheqsy.counts.tenmin.toLocaleString() },
                { name: 'Hour', value: _ctx.receiverStats.sheqsy.counts.hour.toLocaleString() },
                { name: 'Today', value: _ctx.receiverStats.sheqsy.counts.today.toLocaleString() },
                { name: 'Total', value: _ctx.receiverStats.sheqsy.counts.total.toLocaleString() }
            ]
          }, null, 8, ["title", "counters"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.receiverStats.actions)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_ReceiverStatsDisplayCard, {
            label: 'Processor',
            title: _ctx.getHumanDateOffset(_ctx.receiverStats.actions.last.ReceiverAction[_ctx.receiverStats.actions.last.ReceiverAction.length - 1].Generated) + ' : ' + _ctx.receiverStats.actions.last.ReceiverAction[_ctx.receiverStats.actions.last.ReceiverAction.length - 1].ReceiverStatus + ' `' + _ctx.receiverStats.actions.last.SourceEvent.Message + '`',
            counters: [
                { name: '10 min', value: _ctx.receiverStats.actions.counts.tenmin.toLocaleString() },
                { name: 'Hour', value: _ctx.receiverStats.actions.counts.hour.toLocaleString() },
                { name: 'Today', value: _ctx.receiverStats.actions.counts.today.toLocaleString() },
                { name: 'Total', value: _ctx.receiverStats.actions.counts.total.toLocaleString() }
            ]
          }, null, 8, ["title", "counters"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.receiverStats.signals)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_ReceiverStatsDisplayCard, {
            label: 'Signals',
            title: _ctx.getHumanDateOffset(_ctx.receiverStats.signals.last.Generated) + ' : ' + (_ctx.receiverStats.signals.last.CorrelationEvent ? _ctx.receiverStats.signals.last.CorrelationEvent.SourceEvent.Message : _ctx.receiverStats.signals.last.InternalEvent.Message),
            counters: [
                { name: '10 min', value: _ctx.receiverStats.signals.counts.tenmin.toLocaleString() },
                { name: 'Hour', value: _ctx.receiverStats.signals.counts.hour.toLocaleString() },
                { name: 'Today', value: _ctx.receiverStats.signals.counts.today.toLocaleString() },
                { name: 'Total', value: _ctx.receiverStats.signals.counts.total.toLocaleString() }
            ]
          }, null, 8, ["title", "counters"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_ReceiverStatsDisplayCard, {
        label: 'Events',
        title: _ctx.getHumanDateOffset(_ctx.receiverStats.alerts.last.Generated) + ' : ' + _ctx.receiverStats.alerts.last.Message,
        counters: [
                { name: '10 min', value: _ctx.receiverStats.alerts.counts.tenmin.toLocaleString() },
                { name: 'Hour', value: _ctx.receiverStats.alerts.counts.hour.toLocaleString() },
                { name: 'Today', value: _ctx.receiverStats.alerts.counts.today.toLocaleString() },
                { name: 'Total', value: _ctx.receiverStats.alerts.counts.total.toLocaleString() }
            ]
      }, null, 8, ["title", "counters"])
    ])
  ], 64))
}